import qs from 'qs';
import { AxiosResponse } from 'axios';

import ApiService from 'services/ApiService/ApiService';
import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';
import { BOOST_CAM_ERROR, BOOST_CAM_RESPONSE } from 'services/MessagingService/EventNames';
import getMessagingServiceInstance, { MessagingService } from 'services/MessagingService/MessagingService';
import parseCatch from 'utils/parseCatch';
import { User } from 'stores/UserStore/UserStore.types';


const WEBCHAT_HOST = ConfigurationService.get(ConfigurationKeys.WEB_CHAT_HOST);
const BOOST_CAM_URL = `${WEBCHAT_HOST}boosted-rooms`;


type BoostData = {
  accessHash: string;
  username: User['username'];
  roomName?: string;
  freeBoost?: boolean;
}

export class BoostService {

  constructor(public messagingService: MessagingService) {}

  destructor() {
    this.messagingService = null;
  }

  /**
   * @async
   * @emits BOOST_CAM_RESPONSE when API call is successful
   * @emits BOOST_CAM_ERROR when API call fails
   */
  boostCam = (data: BoostData): Promise<void> =>
    ApiService.post(BOOST_CAM_URL, {
      data: qs.stringify(data),
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
    })
      .then((res) => {
        const dataToPass = { ...data, ...res.data };
        this.messagingService.emit(BOOST_CAM_RESPONSE, dataToPass);
      })
      .catch((error) => {
        this.messagingService.emit(BOOST_CAM_ERROR, error);
      });

  /**
   * @async
   * Method for checking if user has used his free boost for a given period
   */
  getAvailableFreeBoosts = (data: BoostData): Promise<AxiosResponse | void> => {
    const { accessHash, username, freeBoost = true } = data;
    const queryParams = {
      accessHash,
      username: encodeURIComponent(username),
      freeBoost,
    };

    return ApiService.get(BOOST_CAM_URL, { params: queryParams })
      .then((response) => response)
      .catch((error) => parseCatch(error));
  };
}

export default new BoostService(getMessagingServiceInstance());
